import { ButtonPassThrough } from "primeng/button";

export const buttonPtOptions: ButtonPassThrough = {
    root: {
        class: "hover:bg-black/10 active:bg-black/10",
    },
};
